import {useEffect, useState} from "react";

import SwitchView from "@/components/SwitchView";
import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";
import VLFTextField from "@/components/Input/TextField";
import EmptyData from "@/components/EmptyData";

import {REQUIRED_FIELD, tqrOptions} from "@/utils/constants";
import {checkRequiredFields, playerToOption} from "@/utils/functions";

function HandlePlayersDataModal(props) {
	const {open, confirm, close, initialData, type, categories, teams, players} =
		props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	const [insertType, setInsertType] = useState("single");
	const [currentCategory, setCurrentCategory] = useState();
	const [categoryPlayers, setCategoryPlayers] = useState([]);

	useEffect(() => {
		if (!open) {
			setFormData({});
			setCurrentCategory();
		}
	}, [open]);

	useEffect(() => {
		if (initialData) {
			setFormData({
				...formData,
				...initialData,
			});
		}
	}, [initialData]);

	useEffect(() => {
		if (insertType === "multiple" && currentCategory?.value) {
			const categoryTeam =
				teams?.filter(
					(t) => t.playerCategoryId === currentCategory?.value,
				)?.[0] || {};
			const categoryPlayers = categoryTeam?.players?.map((p) => p.player) || [];

			const playersValues = {};
			categoryPlayers?.forEach((p) => {
				playersValues[p.id] = {
					player: playerToOption(p),
				};
			});
			setFormData({...formData, players: playersValues});
			setCategoryPlayers(categoryPlayers);
		}
	}, [insertType, currentCategory]);

	const getRequiredFields = () => {
		if (insertType === "single") {
			if (type === "tqr") {
				return ["player", "tqr"];
			} else {
				if (!formData?.height && !formData?.weight) {
					return ["height"];
				}
			}
		}

		return [];
	};

	const renderSingleFields =
		type === "tqr" ? (
			<>
				<div className="col-12 col-lg-6 padding-small">
					<VLFSelectNew
						options={tqrOptions}
						value={formData.tqr}
						onChange={(value) => {
							setErrors([]);
							setFormData({...formData, tqr: value});
						}}
						required
						helperText={errors.indexOf("tqr") !== -1 ? REQUIRED_FIELD : ""}
						error={errors.indexOf("tqr") !== -1}
						label="TQR"
						sorted={false}
					/>
				</div>
			</>
		) : (
			<>
				<div className="col-12 col-lg-2 padding-small">
					<VLFTextField
						name="height"
						value={formData?.height || ""}
						onChange={(event) => {
							setErrors([]);
							setFormData({...formData, height: event.target.value});
						}}
						required={!formData?.weight}
						helperText={errors.indexOf("height") !== -1 ? REQUIRED_FIELD : ""}
						error={errors.indexOf("height") !== -1}
						label="Altezza (cm)"
						size="small"
						type="number"
					/>
				</div>
				<div className="col-12 col-lg-2 padding-small">
					<VLFTextField
						name="sittingHeight"
						value={formData?.sittingHeight || ""}
						onChange={(event) => {
							setFormData({
								...formData,
								sittingHeight: event.target.value,
							});
						}}
						label="Altezza seduto (cm)"
						size="small"
						type="number"
					/>
				</div>
				<div className="col-12 col-lg-2 padding-small">
					<VLFTextField
						name="weight"
						value={formData.weight || ""}
						onChange={(event) => {
							setErrors([]);
							setFormData({...formData, weight: event.target.value});
						}}
						required={!formData?.height}
						label="Peso (kg)"
						size="small"
						type="number"
					/>
				</div>
			</>
		);

	const getRenderMultipleFields = (p, k) => {
		return type === "tqr"
			? [
					<div key={"tqr_" + k} className="col-12 col-md-3 padding-small">
						<VLFSelectNew
							options={tqrOptions}
							value={formData?.players?.[p.id]?.tqr || ""}
							onChange={(value) => {
								setFormData({
									...formData,
									players: {
										...formData?.players,
										[p.id]: {
											...formData?.players[p.id],
											tqr: value,
										},
									},
								});
							}}
							placeholder="TQR"
							sorted={false}
						/>
					</div>,
				]
			: [
					<div key={"height_" + k} className="col-12 col-md-3 padding-small">
						<VLFTextField
							name="height"
							value={formData?.players?.[p.id]?.height || ""}
							onChange={(event) => {
								setFormData({
									...formData,
									players: {
										...formData?.players,
										[p.id]: {
											...formData?.players[p.id],
											height: event.target.value,
										},
									},
								});
							}}
							placeholder="Altezza (cm)"
							size="small"
							type="number"
						/>
					</div>,
					<div
						key={"sittingHeight_" + k}
						className="col-12 col-md-3 padding-small"
					>
						<VLFTextField
							name="sittingHeight"
							value={formData?.players?.[p.id]?.sittingHeight || ""}
							onChange={(event) => {
								setFormData({
									...formData,
									players: {
										...formData?.players,
										[p.id]: {
											...formData?.players[p.id],
											sittingHeight: event.target.value,
										},
									},
								});
							}}
							placeholder="Altezza seduto (cm)"
							size="small"
							type="number"
						/>
					</div>,
					<div key={"weight_" + k} className="col-12 col-md-3 padding-small">
						<VLFTextField
							name="weight"
							value={formData?.players?.[p.id]?.weight || ""}
							onChange={(event) => {
								setFormData({
									...formData,
									players: {
										...formData?.players,
										[p.id]: {
											...formData?.players[p.id],
											weight: event.target.value,
										},
									},
								});
							}}
							placeholder="Peso (kg)"
							size="small"
							type="number"
						/>
					</div>,
				];
	};

	const formattedPlayers = (
		currentCategory?.value ? categoryPlayers : players
	)?.map((p) => playerToOption(p));

	const isConfirmEnabled = () => {
		let typeCondition = true;

		switch (type) {
			case "tqr":
				typeCondition = formData?.tqr;
				break;
			default:
				typeCondition = formData?.height || formData?.weight;
				break;
		}

		return (
			!errors.length &&
			(insertType !== "single" || (insertType === "single" && typeCondition))
		);
	};

	return (
		<VLFModal
			maxWidth="lg"
			open={open}
			title="Aggiungi informazione"
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(getRequiredFields(), formData);
				setErrors(errors);

				if (isConfirmEnabled()) {
					confirm(formData);
				}
			}}
			content={
				<div className="row no-margin">
					{!initialData ? (
						<div className="col-12 padding-small">
							<SwitchView
								currentSwitchView={insertType}
								setCurrentSwitchView={setInsertType}
								pageOptions={[
									{value: "single", label: "Singolo"},
									{value: "multiple", label: "Multiplo"},
								]}
								fixed
								callback={() => {
									setCurrentCategory();
									setFormData({
										player: null,
										players: null,
									});
								}}
							/>
						</div>
					) : null}
					{insertType === "multiple" ? (
						<>
							<div className="col-12 col-md-6 padding-small">
								<VLFSelectNew
									key="category"
									options={categories?.filter(
										(c) => c.name !== "Prima Squadra",
									)}
									sorted={false}
									value={currentCategory}
									onChange={setCurrentCategory}
									label="Categoria"
								/>
							</div>
							<div className="col-12 col-md-6 padding-small"></div>
							{categoryPlayers
								?.sort((a, b) => {
									const nameA = a?.lastName.toLowerCase();
									const nameB = b?.lastName.toLowerCase();

									if (nameA < nameB) return -1;
									if (nameA > nameB) return 1;
									return 0;
								})
								?.map((p, k) => {
									return [
										<div
											key={"player_" + k}
											className="col-12 col-md-3 padding-small"
										>
											<VLFSelectNew
												options={formattedPlayers}
												sortKey="sortKey"
												value={formData?.players?.[p.id]?.player.label || ""}
												onChange={(value) => {
													setFormData({
														...formData,
														players: {
															...formData?.players,
															[p.id]: {
																...formData?.players[p.id],
																player: value,
															},
														},
													});
												}}
												editable={false}
											/>
										</div>,
										...getRenderMultipleFields(p, k),
									];
								})}
							{!categoryPlayers?.length ? <EmptyData /> : null}
						</>
					) : (
						<>
							<div className="col-12 col-lg-6 padding-small">
								<VLFSelectNew
									options={formattedPlayers}
									sortKey="sortKey"
									value={
										initialData
											? formData?.player?.label
											: formData?.player || ""
									}
									onChange={(value) => {
										setErrors([]);
										setFormData({...formData, player: value});
									}}
									required
									helperText={
										errors.indexOf("player") !== -1 ? REQUIRED_FIELD : ""
									}
									error={errors.indexOf("player") !== -1}
									label="Giocatore"
									editable={!initialData}
								/>
							</div>
							{renderSingleFields}
						</>
					)}
				</div>
			}
		/>
	);
}

export default HandlePlayersDataModal;
